import { render, staticRenderFns } from "./AllTopicContent.vue?vue&type=template&id=31fe97b6&scoped=true"
import script from "./AllTopicContent.vue?vue&type=script&lang=js"
export * from "./AllTopicContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fe97b6",
  null
  
)

export default component.exports